import { connect } from 'react-redux';
import { compose } from 'redux';
import OpenPTOs from './Open';
import { fetchOpenPTOs, setFilterDrawerOpen } from '../store/openOrder';

const mapStateToProps = state => ({
  filterDrawerOpen: state.pto.openPtos.filterDrawerOpen,
});

const mapDispatchToProps = {
  fetchOpenPTOs,
  setFilterDrawerOpen,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(OpenPTOs);
